import React from 'react';

// Curbside Icon Component
export const CurbsideIcon = ({ className = "w-8 h-8", alt = "Curbside" }) => (
  <img 
    src="https://storage.thesavants.ai/storage/v1/object/public/Pictures//Icon-Curbside.png" 
    className={className} 
    alt={alt}
    style={{
      filter: 'brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(3201%) hue-rotate(216deg) brightness(95%) contrast(101%)'
    }}
  />
); 